export const replaceSpacesWith = (str: string, replacement: string): string =>
  str.replace(/\s+/g, replacement).trim();
